(() => {
  if (window.PawpetBrandsAZMenuLoaded) return;
  window.PawpetBrandsAZMenuLoaded = true;

  const initialiseMenu = (root) => {
    if (!root || root.dataset.pawpetBrandsReady === 'true') return;

    const letterButtons = [...root.querySelectorAll('[data-pawpet-brand-letter]')];
    const vendorLinks = [...root.querySelectorAll('[data-pawpet-vendor-letter]')];
    const currentLetter = root.querySelector('[data-pawpet-current-letter]');
    const vendorList = root.querySelector('[data-pawpet-vendor-list]');
    const emptyState = root.querySelector('[data-pawpet-vendor-empty]');
    const emptyLetter = root.querySelector('[data-pawpet-empty-letter]');

    if (!letterButtons.length) return;
    root.dataset.pawpetBrandsReady = 'true';

    const selectLetter = (letter) => {
      let visibleCount = 0;

      letterButtons.forEach((button) => {
        const isActive = button.dataset.pawpetBrandLetter === letter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      vendorLinks.forEach((link) => {
        const isVisible = link.dataset.pawpetVendorLetter === letter;
        link.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (currentLetter) currentLetter.textContent = letter;
      if (emptyLetter) emptyLetter.textContent = letter;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (vendorList) vendorList.scrollTop = 0;
    };

    letterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectLetter(button.dataset.pawpetBrandLetter);
      });
    });

    /*
     * Paw Pet's tile navigation can wrap onto two rows on smaller desktops.
     * Keep the Brands panel open briefly while the pointer crosses that
     * second row, so the menu still works if BRANDS A-Z is moved to the front.
     */
    const menuItem = root.closest('.submenu--brands-az');
    if (menuItem) {
      let closeTimer;
      const openMenu = () => {
        window.clearTimeout(closeTimer);
        menuItem.classList.add('is-open');
      };
      const queueClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          menuItem.classList.remove('is-open');
        }, 450);
      };

      const trigger = menuItem.querySelector(':scope > a');
      trigger?.addEventListener('pointerenter', openMenu);
      trigger?.addEventListener('focus', openMenu);
      menuItem.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
      menuItem.addEventListener('pointerleave', queueClose);
      menuItem.addEventListener('focusout', (event) => {
        if (!menuItem.contains(event.relatedTarget)) {
          window.clearTimeout(closeTimer);
          menuItem.classList.remove('is-open');
        }
      });
    }

    selectLetter(root.dataset.defaultLetter || 'A');
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches?.('[data-pawpet-brands-menu]')) initialiseMenu(scope);
    scope.querySelectorAll('[data-pawpet-brands-menu]').forEach(initialiseMenu);
  };

  initialiseAll();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAll(event.target);
  });
})();
